import React from 'react';
import BiLink, { Props as BiLinkProps } from '@wix/da-bi/pkg/Components/BiLink';
import s from './ModalLink.scss';

interface Props extends BiLinkProps {}

const ModalLink: React.FC<Props> = props => (
  <BiLink className={s['root']} {...props} />
);
ModalLink.displayName = 'ModalLink';

export default ModalLink;
